import angular from "angular";
import LogInPageComponent from "./log-in-page/log-in-page";
import SignUpPageComponent from "./sign-up-page/sign-up-page";
import VerifyEmailPageComponent from "./verify-email-page/verify-email-page";

const AuthModule = angular
  .module("modules.auth", [])
  .component("logInPage", LogInPageComponent)
  .component("signUpPage", SignUpPageComponent)
  .component("verifyEmailPage", VerifyEmailPageComponent);

export default AuthModule;
